import { FetchStatus, PageMode, QueryType } from "../../../base/types";
import { IPage, IPageView, PageType } from "../models";
import { getFilterGroups, getQueryFields } from "../../helpers";

import { useDataContext } from "./DataContextProvider";
import { useEffect } from "react";
import { useReadAttributes } from "../../../base/hooks";

export const usePageParameters = ({ page, pageView }: { page: IPage, pageView: IPageView }) => {
    const { readAttributes } = useReadAttributes();
    const { setData, dataSource, setDataSource, fetch } = useDataContext()

    useEffect(() => {
        if (!page.sourceObject) {
            setData({ type: "Static", status: FetchStatus.Success })
            return;
        }

        const entity = page.sourceObject;
        readAttributes(entity)
            .then(attributes => setDataSource({ entity, attributes }))
        // eslint-disable-next-line
    }, [page])

    useEffect(() => {
        if (!dataSource)
            return;

        loadPageData()
        // eslint-disable-next-line
    }, [dataSource])

    const loadPageData = () => {
        if (pageView.pageMode === PageMode.New) {
            setData({ type: "Card", result: {}, status: FetchStatus.Success })
            return;
        }

        const fields = getQueryFields(page.controls || [], page.actions || [], page.filters || []);
        const filters = getFilterGroups({ page, pageView })

        if ((page.type === PageType.Card || page.type === PageType.CardPart) && pageView.systemId) {
            fetch({
                queryType: QueryType.Record,
                query: { id: pageView.systemId, fields }
            });
        } else if (page.type === PageType.List || page.type === PageType.ListPart) {
            fetch({
                queryType: QueryType.MultipleRecords,
                query: { fields, filters, orderBy: page.orderBy, pageSize: page.recordLimit }
            })
        } else {
            fetch({
                queryType: QueryType.FirstRecord,
                query: { fields, filters, orderBy: page.orderBy, pageSize: page.recordLimit }
            })
        }
    }
}